<template>
  <div id="app">
    <div class="hero"></div>
    <div class="wrapper">
      <img src="./assets/header.png" class="pure-img title" alt="Pogocat">
      <div class="content">
        <div class="header">
          <nav id="nav">
            <router-link class="router-link" to="/about">About</router-link>
            <router-link class="router-link" to="/privacy">Privacy</router-link>
            <router-link class="router-link" to="/press">Press</router-link>
            <router-link class="router-link" to="/support">Support</router-link>
          </nav>
        </div>
        <img src="./assets/icon.png" class="sticker" alt="Pogocat">
        <main>
          <router-view/>
        </main>
          <signup-form></signup-form>
        <footer>
          &copy; 2018 <a href="https://2pt.com.au" target="_blank">2pt Pty Ltd</a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import SignupForm from "@/components/SignupForm";
export default {
  components: {
    SignupForm
  }
};
</script>

<style lang="scss">
$c-gray: #6e7477;
$c-red: #e23c45;

html,
body {
  background-color: #34dafd;
  font-family: "PT Sans", sans-serif;
}
a {
  color: $c-gray;
}
footer {
  text-align: center;
  font-size: 0.75rem;
}
.content {
  border-radius: 0px 0px 4px 4px;
  background-color: white;
  padding: 4px 64px 64px 64px;
  @media screen and (max-width: 512px) {
    padding: 16px;
  }
}
nav {
  .router-link {
    text-decoration: none;
  }
  .router-link-active {
    text-decoration: underline;
    font-weight: bold;
  }
}
#app {
  overflow-x: hidden;
  margin: auto;
}
.opt-out-option {
  margin-bottom: 16px;
}
main > .section {
  margin-bottom: 32px;
}
.hero {
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-image: url("./assets/hero.jpg");
}
.sticker {
  position: absolute;
  width: 160px;
  height: 160px;
  margin-left: -80px;
  margin-top: -80px;
  left: 50%;
  top: 0px;
}
@media screen and (max-width: 640px) {
  .sticker {
    width: 128px;
    height: 128px;
    margin-left: -64px;
    margin-top: -64px;
  }
}
.header {
  padding-top: 32px;
  border-radius: 4px 4px 0px 0px;
  background-color: white;
  padding-bottom: 16px;
}
#nav {
  margin: auto;
  margin-top: 64px;
  display: flex;
  padding: 16px 0px 16px 0px;
  justify-content: space-evenly;
  max-width: 512px;
  font-size: 18px;
  background-color: white;
  @media screen and (max-width: 640px) {
    margin-top: 32px;
    font-size: 14px;
    > a {
      border-width: 1px;
    }
  }
  > a {
    box-shadow: 0px 4px 16px transparentize($c-gray, $amount: 0.7);
    border-radius: 32px;
    padding: 8px 16px 8px 16px;
    color: $c-gray;
    transition: transform 0.25s;
    &:hover {
      transform: scale(1.15);
    }
  }
}
.nav-item {
  flex-grow: 1;
  text-align: center;
}
.title {
  max-width: 90%;
  margin: auto;
  margin-top: 32px;
  display: block;
  margin-bottom: 64px;
}
.wrapper {
  position: relative;
  z-index: 2;
  max-width: 768px;
  margin: auto;
}
h1 {
  font-size: 2.5rem;
  margin-bottom: 0px;
}
.subheading {
  font-size: 1.5rem;
  margin: 0px;
}
.content {
  position: relative;
  color: #6e7477;
  border-radius: 4px;
  padding-bottom: 16px;
  margin-bottom: 256px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
